import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Dropdown, Input, Option } from "@fluentui/react-components";
import { Spinner, SpinnerSize } from "@fluentui/react";

import Pagination from "../../components/pagination/Pagination";
import TableComponent from "../../components/table/TableComponent";
import { AdminService, ApplicationUserDto } from "../../KulcsUzletSvc";
import { useStylesMainPage } from "../../styles/MainPageStyle";
import { TABLE } from "../../utils/Enums";

export default function MerchantsPage() {
  const styles = useStylesMainPage();
  const [data, setData] = useState<null | ApplicationUserDto[]>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const navigateBack = () => {
    navigate(-1);
  };

  const [pageSize, setPageSize] = useState("50");
  const [currentPage, setCurrentPage] = useState(1);

  const filteredData = useMemo(() => {
    if (!data) return [];
    if (!search) return data;

    const searchValue = search.toLowerCase();

    return data.filter((item) => {
      const fullName = item.fullName?.toLowerCase() ?? "";
      const userName = item.userName?.toLowerCase() ?? "";
      const email = item.emailAddress?.toLowerCase() ?? "";

      return (
        fullName.includes(searchValue) ||
        userName.includes(searchValue) ||
        email.includes(searchValue)
      );
    });
  }, [data, search]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await AdminService.getAdminApplicationUsers();
      if (res) setData(res.items ?? []);
    } catch (e) {
      console.error("Hiba az adatok lekérésekor:", e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRowAction = async (
    actionOrOid: string | null | undefined,
    item?: ApplicationUserDto,
  ) => {
    if (actionOrOid === "deleteMerchant") {
      const ok = window.confirm(
        `Biztosan törölni szeretnéd a kereskedőt: ${
          item?.fullName ?? item?.userName
        }?`,
      );
      if (!ok) return;
      try {
        if (item?.id) {
          await AdminService.deleteAdminApplicationUser(item.id);
          await getData();
          alert("Törlés sikeres");
        } else {
          alert("Hiba: Nincs kereskedő azonosító!");
        }
      } catch (e) {
        console.error(e);
        alert("A törlés nem sikerült. Részletek a konzolban.");
      }
    }
  };

  return (
    <div className={styles.main}>
      <div
        style={{
          textAlign: "center",
          width: "100%",
          fontWeight: "bold",
          fontSize: "40px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Kereskedők
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          marginBottom: "12px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Button onClick={navigateBack}>Vissza</Button>
          <Dropdown
            defaultValue={"50"}
            style={{ minWidth: "80px" }}
            onOptionSelect={(_, data) =>
              setPageSize(data.optionValue as string)
            }
          >
            <Option value="10">10</Option>
            <Option value="20">20</Option>
            <Option value="50">50</Option>
            <Option value="100">100</Option>
          </Dropdown>
          <span style={{ fontSize: "14px" }}>találat oldalaként</span>
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <Input
            type="text"
            placeholder="Keresés..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "200px" }}
          />

          <Button
            appearance="primary"
            onClick={() => navigate("/admin/trader/create")}
          >
            Új kereskedő
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Spinner size={SpinnerSize.large} label="Betöltés..." />
        </div>
      ) : (
        <>
          <Pagination
            currentPage={currentPage}
            totalItems={filteredData.length}
            pageSize={Number(pageSize)}
            onPageChange={(p) => setCurrentPage(p)}
          />

          <TableComponent
            type={TABLE.MERCHANTS}
            data={filteredData}
            isLoading={isLoading}
            handleRowAction={handleRowAction}
            pageSize={Number(pageSize)}
            currentPage={currentPage}
            onPageChange={(p) => setCurrentPage(p)}
          />
        </>
      )}
    </div>
  );
}
